// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
.ABModal {
    height: 100%;
    
} */
.ABModal .ant-modal-body {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  min-height: 500px;
  background: transparent;
}

.ABTestChart-resposive {
  height: 350px !important;
}

.ABTestChart-resposive .recharts-pie {
  overflow: visible;
}

.ABTestChart-resposive .recharts-pie .recharts-pie-labels .recharts-layer text {
  position: absolute;
  z-index: 30;
}

.ABModal-sec {
  /* flex: 1; */
  width: 50%;
  /* height: 50%; */
  text-align: center;
  background: transparent;
  max-height: 600px;
  box-sizing: border-box;
}

.ABModal-sec h1 {
  text-align: center;
  text-transform: uppercase;
}

.legends-container {
  display: flex;
  justify-content: center;
  gap: 15px;
  align-items: center;
}
.legends-container .legends {
  /* width: 100%; */
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
}
.legends-container .legends .span {
  height: 20px !important;
  width: 20px !important;

  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/ABTesting.css"],"names":[],"mappings":"AAAA;;;;GAIG;AACH;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,sBAAsB;;EAEtB,kBAAkB;AACpB","sourcesContent":["/* \r\n.ABModal {\r\n    height: 100%;\r\n    \r\n} */\r\n.ABModal .ant-modal-body {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  min-height: 500px;\r\n  background: transparent;\r\n}\r\n\r\n.ABTestChart-resposive {\r\n  height: 350px !important;\r\n}\r\n\r\n.ABTestChart-resposive .recharts-pie {\r\n  overflow: visible;\r\n}\r\n\r\n.ABTestChart-resposive .recharts-pie .recharts-pie-labels .recharts-layer text {\r\n  position: absolute;\r\n  z-index: 30;\r\n}\r\n\r\n.ABModal-sec {\r\n  /* flex: 1; */\r\n  width: 50%;\r\n  /* height: 50%; */\r\n  text-align: center;\r\n  background: transparent;\r\n  max-height: 600px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.ABModal-sec h1 {\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.legends-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 15px;\r\n  align-items: center;\r\n}\r\n.legends-container .legends {\r\n  /* width: 100%; */\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n.legends-container .legends .span {\r\n  height: 20px !important;\r\n  width: 20px !important;\r\n\r\n  border-radius: 50%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
